export let hasFilesLabel = "hOgKkc";
export let hasCalendarInviteLabel = "XZ8tQe";
export let highPriorityFilterLabel = "wWWf$";
export default {hasFilesLabel,hasCalendarInviteLabel,highPriorityFilterLabel};